import { useState, useEffect } from 'react';
import { DlqRedriveInfoApiFactory } from '../../../lusca-search-api/LuscaSearchApiFactory';
import { Stage, DLQRedriveInfoResult } from '../../../lusca-search-api/generated-src';

const POLL_INTERVAL_MS = 2000;

export const useDlqRedriveDetails = (stage: Stage, executionArn: string | null) => {
  const [details, setDetails] = useState<DLQRedriveInfoResult | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (!executionArn) {
      setDetails(null);
      return;
    }

    let cancelled = false;
    let pollTimer: ReturnType<typeof setTimeout> | null = null;

    // Poll while PENDING (the step function runs async); stop on COMPLETED/ERROR.
    const fetchDetails = async (isInitial: boolean) => {
      try {
        if (isInitial) {
          setLoading(true);
        }
        setError("");

        const dlqRedriveApi = DlqRedriveInfoApiFactory();
        const response = await dlqRedriveApi.getDLQRedriveInfo(stage, executionArn);

        if (cancelled) {
          return;
        }

        setDetails(response.data);

        if (response.data?.status === "PENDING") {
          pollTimer = setTimeout(() => fetchDetails(false), POLL_INTERVAL_MS);
        } else {
          setLoading(false);
        }
      } catch (error) {
        if (cancelled) {
          return;
        }
        console.error("Error fetching DLQ redrive details:", error);
        setError("Failed to load DLQ redrive details");
        setDetails(null);
        setLoading(false);
      }
    };

    fetchDetails(true);

    return () => {
      cancelled = true;
      if (pollTimer) {
        clearTimeout(pollTimer);
      }
    };
  }, [stage, executionArn]);

  return { details, loading, error };
};
